export const LOGIN = "LOGIN";

export const CREATE_CHECKUP_SUCCESS = "CREATE_CHECKUP_SUCCESS";
export const CREATE_CHECKUP_FAILURE = "CREATE_CHECKUP_FAILURE";
export const CREATE_CHECKUP = "CREATE_CHECKUP";

export const GET_ALL_CHECKUPS_SUCCESS = "GET_ALL_CHECKUPS_SUCCESS";
export const GET_ALL_CHECKUPS_FAILURE = "GET_ALL_CHECKUPS_FAILURE";
export const FETCH_ALL_CHECKUPS = "FETCH_ALL_CHECKUPS";

export const GET_CHECKUP_TYPE_SUCCESS = "GET_CHECKUP_TYPE_SUCCESS";
export const GET_CHECKUP_TYPE_FAILURE = "GET_CHECKUP_TYPE_FAILURE";
export const FETCH_CHECKUP_TYPES = "FETCH_CHECKUP_TYPES";

export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE";
export const CREATE_USER = "CREATE_USER";

export const GET_ALL_USER_SUCCESS = "GET_ALL_USER_SUCCESS";
export const GET_ALL_USER_FAILURE = "GET_ALL_USER_FAILURE";
export const FETCH_ALL_USERS = "FETCH_ALL_USERS";

export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";
export const FETCH_USER = "GET_USER";

export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
export const UPDATE_USER = "UPDATE_USER";

export const CHECK_USER_SUCCESS = "CHECK_USER_SUCCESS";
export const CHECK_USER_FAILURE = "CHECK_USER_FAILURE";
export const CHECK_USER = "CHECK_USER";

export const GET_LIST_OF_PARKS_SUCCESS = "GET_LIST_OF_PARKS_SUCCESS";
export const GET_LIST_OF_PARKS_FAILURE = "GET_LIST_OF_PARKS_FAILURE";
export const FETCH_LIST_OF_PARKS = "FETCH_LIST_OF_PARKS";

export const GET_ALL_STATIONS_SUCCESS = "GET_ALL_STATIONS_SUCCESS";
export const GET_ALL_STATIONS_FAILURE = "GET_ALL_STATIONS_FAILURE";
export const FETCH_ALL_STATIONS = "FETCH_ALL_STATIONS";

export const GET_MODULES_SUCCESS = "GET_MODULES_SUCCESS";
export const GET_MODULES_FAILURE = "GET_MODULES_FAILURE";
export const FETCH_MODULES = "FETCH_MODULES";

export const GET_TASKS_SUCCESS = "GET_TASKS_SUCCESS";
export const GET_TASKS_FAILURE = "GET_TASKS_FAILURE";
export const FETCH_TASKS = "FETCH_TASKS";

export const GET_TASKS_DESCRIPTION_SUCCESS = "GET_TASK_DESCRIPTION_SUCCESS";
export const GET_TASKS_DESCRIPTION_FAILURE = "GET_TASK_DESCRIPTION_FAILURE";
export const FETCH_TASKS_DESCRIPTION = "FETCH_TASK_DESCRIPTION";

export const GET_ALL_CHECK_UPDATES_FAILURE = "GET_ALL_CHECK_UPDATES_FAILURE";
export const GET_ALL_CHECK_UPDATES_SUCCESS = "GET_ALL_CHECK_UPDATES_SUCCESS";
export const FETCH_ALL_CHECK_UPDATES = "FETCH_ALL_CHECK_UPDATES";

export const GET_MODULES_AND_STATION_RATING_SUCCESS =
  "GET_MODULES_AND_STATION_RATING_SUCCESS";
export const GET_MODULES_AND_STATION_RATING_FAILURE =
  "GET_MODULES_AND_STATION_RATING_FAILURE";
export const FETCH_MODULES_AND_STATION_RATING =
  "GET_MODULES_AND_STATION_RATING";

export const ADD_TASK_DES_SUCCESS = "ADD_TASK_DES_SUCCESS";
export const ADD_TASK_DES_FAILURE = "ADD_TASK_DES_FAILURE";
export const ADD_TASK_DES = "ADD_TASK_DES";

export const UPDATE_TASK_DES_SUCCESS = "UPDATE_TASK_DES_SUCCESS";
export const UPDATE_TASK_DES_FAILURE = "UPDATE_TASK_DES_FAILURE";
export const UPDATE_TASK_DES = "UPDATE_TASK_DES";

export const ADD_ORDER_TO_BASKET_SUCCESS = "ADD_ORDER_TO_BASKET_SUCCESS";
export const ADD_ORDER_TO_BASKET_FAILURE = "ADD_ORDER_TO_BASKET_FAILURE";
export const ADD_ORDER_TO_BASKET = "ADD_ORDER_TO_BASKET";

export const GET_ORDER_FROM_BASKET_SUCCESS = "GET_ORDER_FROM_BASKET_SUCCESS";
export const GET_ORDER_FROM_BASKET_FAILURE = "GET_ORDER_FROM_BASKET_FAILURE";
export const GET_ORDER_FROM_BASKET = "GET_ORDER_FROM_BASKET";

export const CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS";
export const CONFIRM_ORDER_FAILURE = "CONFIRM_ORDER_FAILURE";
export const CONFIRM_ORDER = "CONFIRM_ORDER";

export const GET_PAST_ORDERS_SUCCESS = "GET_PAST_ORDER_SUCCESS";
export const GET_PAST_ORDERS_FAILURE = "GET_PAST_ORDER_FAILURE";
export const GET_PAST_ORDERS = "GET_PAST_ORDER";

export const REMOVE_ORDER_SUCCESS = "REMOVE_ORDER_SUCCESS";
export const REMOVE_ORDER_FAILURE = "REMOVE_ORDER_FAILURE";
export const REMOVE_ORDER = "REMOVE_ORDER";

export const BELL_ICON_RESET = "BELL_ICON_RESET";

export const LOG_OUT = "LOG_OUT";
